import { Injectable } from '@angular/core';
import { UtilService } from '../util/util.service';
import { LogService } from '../log/log.service';
import { IVersionService } from './iversion.service';

@Injectable()
export class VersionService implements IVersionService {
  //depends on script tag in index.html which put the version from package.json on the window object

  private _utilService: UtilService;
  private _logService: LogService;

  private _version: string = '1.1.1.1';

  public constructor(utilService: UtilService, logService: LogService) {
    this._utilService = utilService;
    this._logService = logService;

    //window["wlVersion"] = _package.version;
    //return _package.version;
    try {
      let data: any = window['wlVersion'];
      if (this._utilService.isNotNullOrUndefined(data)) {
        if (this._utilService.isNotNullEmptyOrWhitespace(data.WeblinkAuthUrl)) {
          this._version = data;
        }
      } else {
        this._logService.log('version', 'wlVersion undefined.  Using default version number.');
      }
    } catch (e) {
      this._logService.log('version', 'error parsing environment config.  Using default version number.');
    }
  }

  public getVersion = (): string => {
    return this._version;
  };
}
